import { t } from '@lingui/core/macro';

export type OrgUnitEditorContext = 'orgUnits' | 'institutions' | 'mine';

export type EditorContextConfig = {
  /** Where Back goes; null where the page has no list (My Institution). */
  listPath: string | null;
  /** The Institutions page only edits institutions, so the type is fixed and not offered. */
  lockToInstitution: boolean;
  parentLabel: () => string;
  breadcrumb: () => string;
};

const orgUnitLabel = () => __APP_CONFIG__.organizationalUnitLabel ?? t`Organizational Units`;

const CONFIG: Record<OrgUnitEditorContext, EditorContextConfig> = {
  orgUnits: {
    listPath: '/system-settings/organizational-units',
    lockToInstitution: false,
    parentLabel: () => t`Parent Organizational Unit`,
    breadcrumb: orgUnitLabel,
  },
  institutions: {
    listPath: '/system-settings/institutions',
    lockToInstitution: true,
    parentLabel: () => t`Classification`,
    breadcrumb: () => t`Institutions`,
  },
  mine: {
    listPath: null,
    lockToInstitution: false,
    parentLabel: () => t`Classification`,
    breadcrumb: () => t`My Institution`,
  },
};

export function editorContextConfig(context: OrgUnitEditorContext): EditorContextConfig {
  return CONFIG[context];
}
